import * as types from "~/store/followUpExam/types";

export const getFollowUpExam = url => {
  return {
    type: types.GET_FOLLOW_UP_EXAM,
    url
  };
};

export const resetFollowUpExam = () => {
  return {
    type: types.RESET_FOLLOW_UP_EXAM
  };
};

export const checkFollowUpExam = phone => {
  return {
    type: types.CHECK_FOLLOW_UP_EXAM,
    phone
  };
};

export const resetStatucChecking = () => {
  return {
    type: types.RESET_STATUS_CHECKING
  };
};
export const clearListFollowUpExam = () => {
  return {
    type: types.CLEAR_LIST_FOLLOW_UP_EXAM
  };
};
